<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="row" fxLayoutAlign="space-between center">
  <div class="container1">{{ header }}</div>
  <div class="container2 notranslate" (click)="cancelfunction()" i18n>
    Cancel
  </div>
</div>
